/**
 * Shared copy for the home page. Consumed by:
 * - `NewHero.tsx` (rendered into the DOM as the hero subhead)
 * - `PAGE_META["/"]` in `page-meta.ts` (used for <meta name="description">,
 *   og:description, twitter:description, and the OG image PNG via /og/.png)
 *
 * When you edit the hero subhead, update this file. Do not edit the hero
 * JSX or page-meta description directly.
 */
export const HOME_META_TITLE = "Wonda: the agentic browser for social media";

export const HOME_HERO_SUBHEAD =
  "Your agent works in the background on LinkedIn, X and Reddit to find profiles, message, post exactly like you’re doing manually.";
